import React from 'react';

import { Checkbox } from '@mui/material';

import {
  isObjectPredicate,
  shouldShowTrplAsEdited,
} from '../../../utils';
import { savedTrplColor } from '../../../constants';

import MandatoryAlertIcon from './MandatoryAlertIcon';
import Node from '../../Node';

export default (({
  rst,
  data,
  trpls,
  classes,
  constant,
  ancestorId,
  showMandatoryAlert,
  disableTrplEditing,
  onWidgetCheckboxesValueEdit,
}) => {

  const currentTrplsValLength = trpls[trpls.length - 1].hasOwnProperty('pid') ? trpls.length : trpls.length - 1;
  const allTrplsWithValues = isObjectPredicate(rst)
    ? trpls.filter(trpl => trpl.val || trpl.oid).length === rst.values.length
    : trpls.filter(trpl => trpl.val).length === rst.values.length;

  const atLeastOneTrplWithVal = trpls.find(trpl => trpl.hasOwnProperty('tid'));

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

      <div className={classes.alignCenter}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          {(rst.subjectMaxBound === 0 || rst.subjectMaxBound >= rst.values.length) &&
          <div style={{ margin: '10px 5px 10px 8px' }}>
            <Checkbox
              margin="none"
              style={{ color: '#347CFF' }}
              disabled={constant || disableTrplEditing}
              classes={{
                root: classes.trplCheckbox,
              }}
              value={'all'}
              checked={allTrplsWithValues}
              onChange={(e) => onWidgetCheckboxesValueEdit(rst, e.target.checked, 'all', ancestorId)}
            />
            <strong
              style={{
                pointerEvents: (constant || disableTrplEditing) ? 'none' : 'auto',
                marginLeft: '10px',
                fontSize: 12,
                color: '#4C4C4C',
                cursor: 'pointer',
              }}
              onClick={() => onWidgetCheckboxesValueEdit(rst, !allTrplsWithValues, 'all', ancestorId)}
            >
              All
            </strong>
          </div>
          }
          {rst.values && rst.values.map((value, valueIndex) => {
            let isValSelected;
            let trplIndex;
            if (isObjectPredicate(rst)) {
              isValSelected = trpls.some(trpl => +trpl.oid === +value || +trpl.val === +value);
              trplIndex = isValSelected
                ? trpls.findIndex(trpl => +trpl.oid === +value || +trpl.val === +value)
                : trpls.find(trpl => +trpl.oldVal === +value)
                  ? trpls.findIndex(trpl => +trpl.oldVal === +value)
                  : currentTrplsValLength;
            } else {
              isValSelected = trpls.some(trpl => trpl.val === value);
              trplIndex = isValSelected
                ? trpls.findIndex(trpl => trpl.val === value)
                : trpls.find(trpl => trpl.oldVal === value)
                  ? trpls.findIndex(trpl => trpl.oldVal === value)
                  : currentTrplsValLength;
            }

            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  key={valueIndex}
                  className={`${classes.checkboxTrplContainer}
                    ${trpls[trplIndex] && !trpls[trplIndex].tid && trpls[trplIndex].unsaved ? classes.unsavedNewTrpl : ''}`}
                  style={{
                    width: 'fit-content',
                    margin: '5px',
                    background: shouldShowTrplAsEdited(trpls[trplIndex])
                      ? '#d3fff4'
                      : trpls[trplIndex] && trpls[trplIndex].tid ? savedTrplColor : '',
                  }}
                >
                  <Checkbox
                    margin="none"
                    color="default"
                    disabled={constant || disableTrplEditing}
                    classes={{
                      root: classes.trplCheckbox,
                    }}
                    checked={isValSelected}
                    onChange={() => onWidgetCheckboxesValueEdit(rst, value, trplIndex, ancestorId)}
                  />
                </div>
                {isObjectPredicate(rst) ? (
                  <Node
                    isLink
                    size="xs"
                    nodes={data.nodes}
                    nodeId={+value}
                    node={data.nodes[value]}
                    style={{ alignSelf: 'center', cursor: 'pointer' }}
                    onClick={() => onWidgetCheckboxesValueEdit(rst, value, trplIndex, ancestorId)}
                  />
                ) : (
                  <span
                    style={{
                      pointerEvents: (constant || disableTrplEditing) ? 'none' : 'auto',
                      marginLeft: '5px',
                      fontSize: 12,
                      color: '#4C4C4C',
                      cursor: 'pointer',
                    }}
                    onClick={() => onWidgetCheckboxesValueEdit(rst, value, trplIndex, ancestorId)}
                  >
                    {value}
                  </span>
                )}
              </div>
            )
          })}
        </div>

        <div className={classes.ml20}>
          {!atLeastOneTrplWithVal && showMandatoryAlert && <MandatoryAlertIcon />}
        </div>
      </div>

      <div className={classes.setDeleteTrplBtnsContainer}/>

    </div>
  );
});
